export const signUpStats =
`query MyQuery($role: UserMembershipFilterEnum = ALL, $type: PeriodType = DAILY) {
    userSignUpStats(type: $type, role: $role) {
      count
      label
    }
  }
`